import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRedactPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#1BCFC4" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.14 9.958v-1.21c0-1.195 0-1.793-.233-2.25a2.13 2.13 0 0 0-.933-.932c-.457-.233-1.054-.233-2.25-.233H8.748c-1.195 0-1.793 0-2.25.233a2.13 2.13 0 0 0-.932.933c-.233.456-.233 1.054-.233 2.25v1.707c0 1.195 0 1.793.233 2.25.205.4.531.727.933.932.456.233 1.054.233 2.25.233m6.82 1.928-1.209 2.244c-.197.367-.296.55-.417.598a.36.36 0 0 1-.318-.027c-.11-.068-.175-.266-.306-.662L11.38 12.1c-.115-.346-.172-.52-.131-.635.036-.1.115-.18.215-.215.116-.041.289.016.635.13l5.852 1.939c.396.13.594.196.662.306.059.096.069.214.027.318-.047.12-.23.22-.598.417L15.8 15.568a1 1 0 0 0-.109.065.4.4 0 0 0-.058.058 1 1 0 0 0-.065.108"
    />
  </svg>
);
export default SvgRedactPdf;
